import { useRouterState } from '@tanstack/react-router';
import {
  AdministrationOverlaySuffix,
  readAdministrationOverlay,
} from '../administrationOverlayRewrite';

/** Active administration overlay from rewrite search (fallback: public URL). */
export function useAdministrationOverlay(): AdministrationOverlaySuffix | null {
  return useRouterState({
    select: state => readAdministrationOverlay(state.location),
  });
}
